import { useContext } from "react";
import MainCard from "../../components/OB/MainCard";
import { ConstantAPISContext } from "../../context/ConstantAPISContext";

const Anasayfa = () => {
  const {menuList}=useContext(ConstantAPISContext)
  return (
    <div className="container-fluid">
      
      <div className="row">
        {
          menuList.map((item,number)=>{
            return <MainCard key={number} sqId={item.sqId} title={item.ustBaslik.menuAdi} iconPath={item.ustBaslik.ikonYolu} altBasliklar={item.altBasliklar} sayfaLink={item.ustBaslik.sayfaLink} />
          })
        }
       
      </div>
    </div>
  );
};
export default Anasayfa;
